import React from 'react';
import Anime from 'react-anime';
import './PhaseFourAnimation.scss';
export default ({ isActive }) => {
  const slideBall = {
    translateY: [
      { value: '100vh', duration: 0 },
      { value: '-100vh', duration: 2000, easing: 'easeOutSine' },
    ]
  }

  return (
    <div className="phase-four-animation">
      <div className="title-bar-phase-four">
        <p className="primary-large white-text">Phase 4</p>
        <p className="secondary-large white-text">AFTER APPROVAL</p>
      </div>
      {isActive && (
        <Anime className="pipe">
          <div className="pipe-cap"></div>
          <Anime {...slideBall} className="ball">
            <div></div>
          </Anime>
          <div className="pipe-body"></div>
        </Anime>
      )}
    </div>
  );
}